module.exports = __webpack_public_path__ + "img/simplicity.28a06e1b.svg";